export default [
  {
    title: 'Reconcile Payment',
    customIcon: 'ReconcilePaymentSVG',
    children: [
      {
        title: 'Reconcile Payment',
        route: "custom-reconcile-payment-list",
        path: "/custom-reconcile-payment/list",
      },
      {
        title: 'Edit Transaction',
        route: "custom-reconcile-payment-all",
        path: "/custom-reconcile-payment/edit-transaction-list",
      },
    ]
  },
]